import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./style.css";
import Captcha from "../Captcha";
import axios from "axios";

const UserSignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [error, setError] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleCaptchaChange = (isCorrect) => {
    setIsCaptchaCorrect(isCorrect);
  };

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = [];

    if (!isCaptchaCorrect) {
      errors.push("Captcha answer is incorrect. Please try again.");
    }

    if (!isValidName(firstName)) {
      errors.push("First name must have at least 2 characters.");
    }

    if (!isValidName(lastName)) {
      errors.push("Last name must have at least 2 characters.");
    }

    if (!username || !email || !password) {
      errors.push("Please fill in all fields.");
    }

    if (!isValidEmail(email)) {
      errors.push("Please enter a valid email address.");
    }

    if (!isValidUsername(username)) {
      errors.push("Username must be at least 5 characters long.");
    }

    if (!isValidPassword(password)) {
      errors.push("Password must meet the following criteria:");
      errors.push("- One uppercase letter");
      errors.push("- One lowercase letter");
      errors.push("- One special character (@, $, !, %, *, ?, &)");
      errors.push("- One number");
      errors.push("- At least 8 characters long");
    }

    if (errors.length > 0) {
      setError(errors);
      return;
    }

    setError([]);

    try {
      const response = await axios.post(
        "https://jacobjose.azurewebsites.net/api/user/create",
        {
          firstName,
          lastName,
          email,
          username,
          password,
        },
      );

      if (response.status === 200) {
        setSuccessMessage("User sign-up successful");
        history.push("/UserSignIn");
      } else {
        errors.push("User sign-up failed. Please try again.");
        setError(errors);
      }
    } catch (error) {
      console.error("Error:", error);
      errors.push("An error occurred. Please try again later.");
      setError(errors);
    }
  };

  const isValidName = (name) => {
    if (name.length < 2) {
      return false;
    }
    const nameRegex = /^[\p{L}\p{M}\s\-']{2,}$/u;
    return nameRegex.test(name);
  };

  const isValidEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const isValidUsername = (username) => {
    return username.length >= 5;
  };

  const isValidPassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  return (
    <div className="user-sign-up-box">
      <div className="user-sign-up-content">
        <h2>User Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="first-name">First Name:</label>
          <input
            type="text"
            id="first-name"
            name="first-name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />

          <label htmlFor="last-name">Last Name:</label>
          <input
            type="text"
            id="last-name"
            name="last-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />

          <label htmlFor="user-username">Username:</label>
          <input
            type="text"
            id="user-username"
            name="user-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label htmlFor="user-email">Email:</label>
          <input
            type="email"
            id="user-email"
            name="user-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label htmlFor="user-password">Password:</label>
          <input
            type="password"
            id="user-password"
            name="user-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Captcha onCaptchaChange={handleCaptchaChange} />

          <button type="submit">Sign Up</button>
        </form>

        {error.length > 0 && (
          <div className="error-message">
            <p>Please fix the following errors:</p>
            <ul>
              {error.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        {successMessage && <p className="success-message">{successMessage}</p>}
      </div>
    </div>
  );
};

export default UserSignUp;
